export default __webpack_public_path__ + "static/media/npm-init.0a2fbe69.png";